import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { IciFlags } from 'src/generated/signalR/ici-flags';
import { CallInformationRemoteDto } from 'src/generated/signalR/call-information-remote-dto';

@Pipe({
   name: 'iciToCallDirectionText',
})
export class IciToCallDirectionTextPipe implements PipeTransform {
   constructor(private translateService: TranslateService) {}

   transform(info: CallInformationRemoteDto): string {
      if (_.isNil(info)) {
         info = {
            ici: IciFlags.UNKNOWN,
            number: '',
            name: '',
         };
      }
      const parts: string[] = [];

      if (info.ici & IciFlags.OUTBOUND) {
         parts.push(this.translateService.instant('samwin.types.ici.outbound'));
      } else if (info.ici & IciFlags.INBOUND) {
         parts.push(this.translateService.instant('samwin.types.ici.inbound'));
      }

      if (info.ici & IciFlags.EXTERNAL) {
         parts.push(this.translateService.instant('samwin.types.ici.external'));
      } else if (info.ici & IciFlags.INTERNAL) {
         parts.push(this.translateService.instant('samwin.types.ici.internal'));
      }

      if (info.ici & IciFlags.CALLBACK) {
         parts.push(this.translateService.instant('samwin.types.ici.callback'));
      }

      return parts.join(' ');
   }

   private formatPeer(num: string, name: string): string {
      if (!_.isNil(name)) {
         return `${name} (${num})`;
      }
      return num;
   }
}
